import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import backgroundImg from './global.svg';
import backgroundImgTablet from './global_tablet.svg';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';

export const contentTabItemCss = css({});
export const activeContentTab = css({});

export const containerMarginCss = css({
  marginBottom: 55,
});

export const backgroundCircle = css({
  // background: `url(${backgroundImg})`,
  // backgroundRepeat: 'no-repeat',
  // backgroundPosition: 'right',

  [MediaQueries.sm]: {
    backgroundSize: '182px',
    backgroundPosition: '255px 120px',
    width: '100%',
    paddingLeft: '24px',
    paddingRight: '24px',
  },

  [MediaQueries.lg]: {
    backgroundSize: '392px',
  },

  '.textArea': {
    [MediaQueries.xl]: {
      paddingBottom: '112px',
      paddingTop: '96px',
      paddingLeft: '90px',
      minHeight: '328px',
    },
    [MediaQueries.sm]: {
      paddingBottom: '32px',
      paddingTop: '0px',
    },
    [MediaQueries.md]: {
      paddingBottom: '32px',
      paddingTop: '32px',
      paddingLeft: '0px',
    },
    [MediaQueries.lg]: {
      paddingBottom: '80px',
      paddingTop: '88px',
      maxWidth: '540px',
      paddingLeft: '48px',
    },
  },

  h2: {
    fontSize: '40px',
    lineHeight: '40px',
    letterSpacing: '-0.30000001192092896px',
    textAlign: 'left',
    fontWeight: 500,
    marginBottom: '32px',
    color: colorsPalette.black,
    [MediaQueries.sm]: {
      marginBottom: '32px',
      fontSize: '32px',
      lineHeight: '32px',
      letterSpacing: '-0.4px',
    },
  },

  p: {
    fontSize: '22px',
    fontStyle: 'normal',

    lineHeight: '24px',
    letterSpacing: '-0.4000000059604645px',
    textAlign: 'left',
    color: colorsPalette.grey90,
  },

  '.ctabtn': {
    '.ctabutton': {
      width: '192px',
      borderRadius: '8px',
      fontSize: '14px',
      textDecoration: 'none',
      minHeight: '56px',
      cursor: 'pointer',
      marginBottom: '0px',
      display: 'flex',
      textTransform: 'uppercase',
      minWidth: '120px',
      lineHeight: '16px',
      justifyContent: 'center',
      alignItems: 'center',
      background: colorsPalette.red,
      marginLeft: '16px',
      color: colorsPalette.white,
      border: '0px',
      letterSpacing: '0.88px',
      '&:hover': {
        background: '#d42705',
        outlineColor: '#d42705',
      },
      [MediaQueries.sm]: {
        maxWidth: 'none',
        marginLeft: '0px',
        width: '100%',
        marginBottom: '48px',
      },
      [MediaQueries.md]: { marginLeft: '0px' },
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [MediaQueries.sm]: { display: 'block', paddingBottom: '0px' },
  },
});

export const containerPaddingCss = css({
  backgroundImage: `url(${backgroundImg})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: '420px',
  backgroundPosition: 'center right 15px',
  [MediaQueries.lg]: {
    backgroundSize: '400px',
    backgroundPosition: 'center right 20px',
  },

  [MediaQueries.md]: {
    backgroundSize: '250px',
    backgroundImage: `url(${backgroundImgTablet})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center right 30px',
    paddingBottom: '32px',
    paddingTop: '32px',
  },

  [MediaQueries.sm]: {
    paddingBottom: '0px',
    paddingTop: '48px',
    paddingBottom: '0px',
    backgroundSize: '182px',
    backgroundPosition: 'right -61px bottom 16px',
  },
});

export const browseresionContainer = css({
  [MediaQueries.sm]: { padding: '0px 0px' },
});
